import { render, staticRenderFns } from "./NewsCard.vue?vue&type=template&id=9aeb3d36&scoped=true"
import script from "./NewsCard.vue?vue&type=script&lang=js"
export * from "./NewsCard.vue?vue&type=script&lang=js"
import style0 from "./NewsCard.vue?vue&type=style&index=0&id=9aeb3d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aeb3d36",
  null
  
)

export default component.exports